import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    rejectedTitle: {
        id: 'notification.kyc.rejected.title',
        defaultMessage: 'KYC rejected',
    },
    informationRequestedTitle: {
        id: 'notification.kyc.information_requested.title',
        defaultMessage: 'Info requested',
    },
    rejectedMessage: {
        id: 'notification.kyc.rejected.message',
        defaultMessage: 'Sorry, your KYC request was rejected',
    },
    informationRequestedMessage: {
        id: 'notification.kyc.information_requested.message',
        defaultMessage: 'Sorry, your KYC required.',
    },
    informationRequestedButtonText: {
        id: 'notification.kyc.information_requested.button_text',
        defaultMessage: 'Resolve',
    },
    contactSupport: {
        id: 'notification.kyc.rejected.contact_support',
        defaultMessage: 'Contact support',
    },
    contactSupportLink: {
        id: 'notification.kyc.rejected.contact_support_link',
        defaultMessage: '#',
    },
})
